export default "__VITE_ASSET__tbas2upY__"